var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-row',[_c('v-col',{attrs:{"md":"12","lg":"12","sm":"12","xs":"12"}},[_c('apexchart',{attrs:{"type":"bar","options":_vm.options,"series":_vm.series}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }